import {Routes} from '@src/Constant/routes';
import {RouteConfig} from './types';

export class RouteService {
  private routes: Partial<Record<Routes, RouteConfig>> = {};

  addRoute(key: Routes, config: RouteConfig): void {
    this.routes[key] = config;
  }

  getRoutes(): Partial<Record<Routes, RouteConfig>> {
    return this.routes;
  }

  getRoute(key: Routes): Routes | undefined {
    return key;
  }
}
